import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { cn } from '@/lib/utils';
import dayjs from 'dayjs';

interface FeiertagEntryProps {
  day: dayjs.Dayjs;
}

export function FeiertagEntry({ day }: FeiertagEntryProps) {
  const { feiertage } = useCalendarContext();
  const datum = day.format('YYYY-MM-DD');
  const feiertag = feiertage.find((f) => f.datum === datum);

  return (
    <>
      {feiertag && (
        <div
          className={cn(
            'w-full truncate rounded-md bg-secondary-purple-500 px-2 py-1',
            'text-start text-xs text-white cursor-default',
          )}>
          {feiertag.name}
        </div>
      )}
    </>
  );
}
